import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { FaIcon } from '../FaIcon';
import { ShareMenu } from './ShareMenu';
import { SavedViewsSelector } from './SavedViews/SavedViewsSelector';

class DataExplorerToolbarComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isExportMenuOpen: false,
        };
        this.controlsRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside(event) {
        if (this.controlsRef.current && !this.controlsRef.current.contains(event.target)) {
            this.setState({ isExportMenuOpen: false });
        }
    }

    render() {
        const { t } = this.props;

        return (
            <div className="data-explorer-toolbar">
                {/* Selector de vistas (estilo sets de columnas del tablero) — solo agency users.
                    Absorbe los antiguos botones "Vistas guardadas" y "Guardar como vista". */}
                {this.props.onSelectView && (
                    <SavedViewsSelector
                        currentView={this.props.currentView}
                        dirty={this.props.dirty}
                        savingChanges={this.props.savingChanges}
                        agencyClientId={this.props.agencyClientId}
                        onSelectView={this.props.onSelectView}
                        onClearView={this.props.onClearView}
                        onSaveAsView={this.props.onSaveAsView}
                        onSaveChanges={this.props.onSaveChanges}
                        onDiscardChanges={this.props.onDiscardChanges}
                        onViewUpdated={this.props.onViewUpdated}
                        onOpenPalette={this.props.onOpenSavedViews}
                        onDeleteView={this.props.onDeleteView}
                    />
                )}

                <div className="data-explorer-toolbar__actions">
                    {/* Botón compartir — dropdown unificado (toggle portal + duplicar + copiar enlace). */}
                    <ShareMenu
                        view={this.props.currentView}
                        agencyClientId={this.props.agencyClientId}
                        onShareUrl={this.props.onShareUrl}
                        onViewUpdated={this.props.onViewUpdated}
                    />

                    {/* Botón descarga con dropdown.
                        El ref envuelve SOLO el botón + dropdown (no toda la toolbar) para que el
                        click-outside se dispare al clickear otros botones del toolbar (ej. Compartir),
                        cerrando este menú antes de abrir el otro. */}
                    <div ref={this.controlsRef} style={{ position: 'relative', display: 'inline-block' }}>
                        <button
                            type="button"
                            className="btn chart-controls__action-button no-margin-bottom"
                            title={t('data_explorer.export', 'Exportar')}
                            onClick={() => this.setState({ isExportMenuOpen: !this.state.isExportMenuOpen })}
                        >
                            <FaIcon iconName="download" />
                        </button>

                        {this.state.isExportMenuOpen && (
                            <div className="chart-controls__adjust-menu">
                                <div className="chart-controls__adjust-menu-title">
                                    {t('data_explorer.export', 'Exportar')}
                                </div>
                                <div
                                    onClick={() => {
                                        if (this.props.onDownloadPDF) this.props.onDownloadPDF();
                                        this.setState({ isExportMenuOpen: false });
                                    }}
                                    className="chart-controls__adjust-menu-option"
                                >
                                    {t('data_explorer.export_to_pdf', 'Descargar como PDF')}
                                </div>
                                <div
                                    onClick={() => {
                                        if (this.props.onDownloadCSV) this.props.onDownloadCSV();
                                        this.setState({ isExportMenuOpen: false });
                                    }}
                                    className="chart-controls__adjust-menu-option"
                                >
                                    {t('data_explorer.export_to_csv', 'Exportar a archivo CSV')}
                                </div>
                                <div
                                    onClick={() => {
                                        if (this.props.onExportDataNodeJson) this.props.onExportDataNodeJson();
                                        this.setState({ isExportMenuOpen: false });
                                    }}
                                    className="chart-controls__adjust-menu-option"
                                >
                                    {t('data_explorer.export_data_node_json', 'JSON para Nodo de datos')}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export const DataExplorerToolbar = withTranslation()(DataExplorerToolbarComponent);
